export default "__VITE_ASSET__C6S5Qxso__";